<mat-card fxLayoutGap class="p-3">
  <app-listing-top-bar (textEmitter)="onText($event)" [linkMainBtnQueryParams]="linkMainBtnQueryParams">
  </app-listing-top-bar>
  <div class="v-spacer"></div>
  <ng-template *ngIf="loading; then loadingTrue else loadingFalse"></ng-template>
  <ng-template #loadingTrue>
    <div class="d-flex justify-content-center align-items-center" style="height: 96px;">
      <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
    </div>
  </ng-template>
  <ng-template #loadingFalse>
    <ng-template *ngIf="isError; then isErrorTrue else isErrorFalse"></ng-template>
    <ng-template #isErrorTrue>
      <div class="d-flex justify-content-center align-items-center" style="height: 96px;">
        {{error?.message}}
      </div>
    </ng-template>
    <ng-template #isErrorFalse>
      <table class="table table-borderless m-0">
        <thead class="m-0">
          <tr class="dea-table-row-header m-0">
            <th scope="col-3">DEA-ID</th>
            <th scope="col-3">Autori</th>
            <th scope="col-3">Titolo</th>
            <th scope="col-3">ISBN</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let schoolbook of schoolbooks;" class="user-listing-table-row dea-radius">
            <td class="col-3 py-auto" title="{{schoolbook.titolo}}" (click)="onSelected(schoolbook.id)">
              {{schoolbook.dea_id}}
            </td>
            <td class="col-3 py-auto" title="{{schoolbook.titolo}}" (click)="onSelected(schoolbook.id)">
              {{schoolbook.autori}}
            </td>
            <td class="col-3 py-auto" title="{{schoolbook.titolo}}" (click)="onSelected(schoolbook.id)">
              {{schoolbook.titolo}}
            </td>
            <td class="col-3 py-auto" title="{{schoolbook.titolo}}" (click)="onSelected(schoolbook.id)">
              {{schoolbook.isbn}}
            </td>
          </tr>
        </tbody>
      </table>
      <app-listing-pagination-bar [paginationData]="pagination" (pageEmitter)="onPage($event)">
      </app-listing-pagination-bar>
    </ng-template>
  </ng-template>
</mat-card>